export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/illustration.4407c62.svg";